// extracted by extract-css-chunks-webpack-plugin
module.exports = {"seo":"seo___37Gfh","container":"container___3eC1j","column":"column___aI0zA","wrapper":"wrapper___1WT5k","column-title":"column-title___3UVEy"};